<template>
  <div class="psptl-Loader">
    <div v-for="row in ROWS" :key="row.id" class="psptl-Row">
      <div class="psptl-Row_Name">
        <div class="psptl-Row_Expand">
          <SkeletonItem v-if="row.expandable" :appearance="SQUARE" :size="SM" />
        </div>
        <SkeletonItem :appearance="SQUARE" :size="SM" border-radius="6px" />
        <SkeletonItem :size="XS" :width="row.name" />
      </div>
      <SkeletonItem :appearance="CIRCLE" :size="SM" />
      <SkeletonItem :appearance="SQUARE" :size="SM" />
    </div>
  </div>
</template>

<script setup>
import {
  SKELETON_APPEARANCES,
  SKELETON_SIZES
} from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'PersonalStatisticsProgressViewTableLoader'
})

const { SQUARE, CIRCLE } = SKELETON_APPEARANCES
const { SM, XS } = SKELETON_SIZES

const ROWS = [
  {
    id: 1,
    expandable: true,
    name: '116px'
  },
  {
    id: 2,
    name: '72px'
  },
  {
    id: 3,
    expandable: true,
    name: '96px'
  },
  {
    id: 4,
    name: '90px'
  },
  {
    id: 5,
    expandable: true,
    name: '140px'
  }
]
</script>

<style lang="scss" scoped>
.psptl-Row {
  height: var(--cdpm-row-height, 64px);
  padding: var(--row-padding, 0 24px);
  display: flex;
  align-items: center;
  gap: var(--okr-table-row-gap);
}

.psptl-Row_Name {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--okr-table-row-gap);
}

.psptl-Row_Expand {
  flex-shrink: 0;
  width: var(--okr-table-row-controls-button-width);
  height: var(--okr-table-row-controls-button-width);
}
</style>
